import React, { useEffect, useState } from "react";
import Alert from "../../utils/Alert";

const Distance = (props) => {
  const { remitDistance } = props;

  const [formData, setFormData] = useState({
    pickupLocation: "",
    dropLocation: "",
  });

  const [distance, setDistance] = useState({
    distance: "123 km",
    duration: "2 hours 55 mins",
    value: 122694,
    pickupLocation: "Ahilya Nagar, Maharashtra, India",
    dropLocation: "Pune, Maharashtra, India",
  });
  
  const [errors, setErrors] = useState({});

  useEffect(() => {
    loadGoogleMaps();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.pickupLocation.trim()) {
      newErrors.pickupLocation = "Pickup Location is required.";
    }

    if (!formData.dropLocation.trim()) {
      newErrors.dropLocation = "Drop Location is required.";
    }
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      // remitDistance(distance);
      calculateDistance();
      setErrors({});
    }
  };

  const calculateDistance = () => {
    if (!formData.pickupLocation || !formData.dropLocation) {
      return;
    }
    const service = new window.google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [formData.pickupLocation],
        destinations: [formData.dropLocation],
        travelMode: "DRIVING",
      },
      (response, status) => {
        if (status === "OK") {
          const result = response.rows[0].elements[0];
          if (result.status === "OK") {
            const out = {
              distance: result.distance.text,
              duration: result.duration.text,
              value: result.distance.value,
              pickupLocation: formData.pickupLocation,
              dropLocation: formData.dropLocation,
            };
            setDistance(out);
            remitDistance(out);
          } else {
            Alert.error(`Unable to calculate distance ${result.status}`);
          }
        } else {
          Alert.error(`Error fetching distance matrix: ${status}`);
        }
      }
    );
  };

  const loadGoogleMaps = () => {
    const existingScript = document.querySelector(
      "script[src*='maps.googleapis.com']"
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBd87qYifvG1BLKtBXGyO8vXQM2NwElo7s&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        console.log("Google Maps script loaded successfully.");
        initializeAutocomplete();
      };
      script.onerror = () => {
        console.error("Google Maps script failed to load.");
      };
      document.body.appendChild(script);
    } else {
      console.log("Google Maps script already loaded.");
      initializeAutocomplete();
    }
  };

  const initializeAutocomplete = () => {
    if (window.google && window.google.maps) {
      handlePlaceSelect("pickupLocation");
      handlePlaceSelect("dropLocation");
    } else {
      console.error("Google Maps API is not loaded.");
    }
  };

  const handlePlaceSelect = (inputId) => {
    const input = document.getElementById(inputId);
    const autocomplete = new window.google.maps.places.Autocomplete(input);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      setFormData((prevFormData) => ({
        ...prevFormData,
        [inputId]: place.formatted_address || place.name,
      }));
    });
  };

  return (
    <section className="quote-surface quote-route-surface wow fadeIn" data-wow-delay="0.2s">
      <div className="quote-surface-header">
        <span className="quote-surface-icon">
          <i className="fa fa-route"></i>
        </span>
        <div>
          <span className="quote-surface-kicker">Route details</span>
          <h2>Where are we moving your goods?</h2>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="quote-route-grid">
          <div className="quote-field">
            <label htmlFor="pickupLocation">Pickup location</label>
            <div className="quote-input-shell">
              <i className="fa fa-map-marker-alt quote-input-icon"></i>
                <input
                  type="text"
                  name="pickupLocation"
                  id="pickupLocation"
                  value={formData.pickupLocation}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter pickup address"
                />
            </div>
            {errors.pickupLocation && (
              <small className="quote-field-error">{errors.pickupLocation}</small>
            )}
          </div>
          <div className="quote-route-direction" aria-hidden="true">
            <i className="fa fa-arrow-right"></i>
          </div>
          <div className="quote-field">
            <label htmlFor="dropLocation">Drop location</label>
            <div className="quote-input-shell">
              <i className="fa fa-flag-checkered quote-input-icon"></i>
                <input
                  type="text"
                  name="dropLocation"
                  id="dropLocation"
                  value={formData.dropLocation}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter delivery address"
                />
            </div>
            {errors.dropLocation && (
              <small className="quote-field-error">{errors.dropLocation}</small>
            )}
          </div>
        </div>
        <div className="quote-surface-footer">
          <span className="quote-helper-text">
            <i className="fa fa-shield-alt"></i> Your route is used only to
            calculate distance and pricing.
          </span>
          <button className="quote-primary-action" type="submit">
            Continue <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </form>
    </section>
  );
};

export default Distance;
